import { computed } from "vue";
import { Tag } from "../../models/tags/Tag";
import { IFilterProvider } from "@/interfaces/filter-providers/IFilterProvider";
import { ClearFilters } from "./ClearFilters";
import { Deployment } from "@/Deployment";
import { TagContainer } from "./TagContainer";
import { TagsFactory } from "./TagsFactory";

export default class SelectedFilters {

	public readonly tagContainer: TagContainer;

	private readonly tagFactory: TagsFactory;
	private readonly clearFilters: ClearFilters;

	public constructor(private filterProvider: IFilterProvider) {
		this.tagContainer = new TagContainer();
		this.tagFactory = new TagsFactory(filterProvider);
		this.clearFilters = new ClearFilters(filterProvider);
	}

	public onMounted(): void {
		this.tagContainer.onMounted();
	}

	public onUnmounted(): void {
		this.tagContainer.onUnmounted();
		this.clearFilters.dispose();
		this.tagContainer.dispose();
	}

	public tags = computed(()=> {
		return this.constructTags();
	})

	public removableFiltersCount = computed(() => {
		return this.tags.value.reduce((acc, tag) => acc + tag.count, 0);
	})

	public filtersApplied = computed(() => {
		return this.tags.value.length > 0;
	})

	public clearAll = async (): Promise<void> => {

		const filterKeys = this.tags.value
			.filter(tag => !tag.required)
			.map(tag => tag.key);

		await this.clearFilters.clearAll(filterKeys);
	}

	private constructTags(): Tag[] {
		if (!Deployment.isLatestVersion(this.filterProvider)) {
			return [];
		}

		const selectedKeys = this.filterProvider.getFilterKeySelection();
		const tags: Tag[] = [];

		selectedKeys.forEach(key => {
			tags.push(...this.tagFactory.constructFor(key));
		})

		return tags;
	}
}
